/**
 * Environment Configuration
 * Centralized config for environment variables
 */

export const config = {
  // API Configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://chocolateroom.barodaweb.org/api/v1',
  imageBaseUrl: import.meta.env.VITE_IMAGE_BASE_URL || 'https://chocolateroom.barodaweb.org',
  apiTimeout: 10000, // 10 seconds

  // Environment
  env: import.meta.env.MODE, // 'development' or 'production'
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',

  // Feature Flags
  enableAuth: import.meta.env.VITE_ENABLE_AUTH === 'true',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',

  // Default company code to use for customer-facing public endpoints when no store/company is available
  // Example: VITE_DEFAULT_COMPANY_CODE=tcr-main
  defaultCompanyCode: import.meta.env.VITE_DEFAULT_COMPANY_CODE || null,
};

// Log config in development
if (config.isDevelopment) {
  console.log('🔧 App Config:', config);
}

export default config;
